module.exports = __webpack_public_path__ + "img/rural-banner5.3c780705.jpg";